/**
 * Recently Viewed Items Component
 * Shows the last 20 items the user opened, sorted by last_viewed_at
 */

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import contentService from '../../services/contentService';
import MasonryGrid from './MasonryGrid';

export default function RecentlyViewedItems({ onItemClick, onItemDelete }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?.id) {
      loadRecentlyViewed();
    }
  }, [user?.id]);

  const loadRecentlyViewed = async () => {
    if (!user?.id) return;
    
    setLoading(true);
    try {
      const result = await contentService.getRecentlyViewed(user.id);
      if (result.data) {
        setItems(result.data);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error('[RecentlyViewedItems] Error loading items:', error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="mb-6 text-neutral-500 text-center py-12 relative z-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#7A47F5] mx-auto mb-4"></div>
        <p>Loading recently viewed…</p>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="mb-6 text-neutral-500 text-center py-12 relative z-20">
        <p>No recently viewed items yet.</p>
        <p className="text-sm mt-2">Items you view will appear here.</p>
      </div>
    );
  }

  return (
    <div className="relative z-20">
      {/* Sort info */}
      <div className="mb-4 flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 text-sm text-neutral-600">
          <span>Recently viewed</span>
          <span className="text-neutral-400">·</span>
          <span>{items.length} {items.length === 1 ? 'item' : 'items'}</span>
        </div>
      </div>

      {/* Items grid */}
      <MasonryGrid
        items={items}
        onItemClick={onItemClick}
        onItemDelete={onItemDelete}
      />
    </div>
  );
}


